import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants'

export const Banner = styled.div`
	.img-responsive {
		max-width: 100%;
		display: block;
	}
`

export const Partner = styled.ul`
	width: 72.9%;
	display: flex;
	flex-wrap: wrap;
	padding: 0;
	margin: 0 auto 40px;
	justify-content: center;

	li {
		display: flex;
		padding: 0.5em;
		list-style: none;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			width: 25%;
		}

		.box-partner {
			display: flex;
			flex-direction: column;
			padding: 1em;
			width: 100%;
			align-items: center;

			figure {
				height: 90px;
				max-width: 222px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 0;

				img {
					margin: 0 auto;
					display: block;
					max-width: 100%;
				}
			}

			.partner-list-points {
				text-align: center;
				color: #517abc;
				font-size: 1.8rem;
				font-weight: 600;
				line-height: 30px;
				min-height: 30px;
			}
		}

		footer {
			width: 100%;

			.about {
				display: block;
				background: ${PRIMARY_COLOR};
				color: #fff;
				text-align: center;
				margin: 0 auto;
				width: 80%;
				height: 43px;
				font-size: 1.6rem;
				font-weight: 600;
				line-height: 43px;
			}
		}
	}
`
